import { SoaFrameworkPanel } from "../components/SoaFrameworkPanel";
import { StandardHeader, STANDARD_PAGE_LABELS } from "../components/standards/StandardHeader";

export function Iso45001SoaPage() {
  return (
    <div className="page-pad">
      <StandardHeader
        frameworkId="iso45001"
        page={STANDARD_PAGE_LABELS.soa}
        subtitle="Decide which occupational health and safety controls apply to your organisation, record why, and attach evidence."
      />
      <SoaFrameworkPanel frameworkId="iso45001" />
    </div>
  );
}
